<template>
  <b-overlay :show="loading">
    <b-container fluid>
      <b-row align-h="center">
        <b-col cols="12" lg="8">

          <b-alert v-if="error" show variant="danger" class="mt-2">
            System error - contact tech support.
            <!-- TBD error component. -->
          </b-alert>

          <!-- https://stackoverflow.com/questions/49072799/vuejs-how-to-pass-an-object-as-prop-and-have-the-component-update-sub-objects -->
          <!-- {{searchModel}} -->

          <!-- Search -->
          <div class="div-section-header">
            <b-row>
              <b-col cols="12">
                <div>
                  <span class="txt-section-title">Search Results</span>
                </div>
              </b-col>
            </b-row>
          </div>

          <searchbar v-model="searchModel" @remove-filter="removeFilter"></searchbar>

          <b-alert v-model="noResults" class="mt-3" variant="info">
            No results found for this search.
          </b-alert>

          <!-- Featured CE Content -->
          <div v-if="featuredClass || featuredPodcast || featuredBlog">
            <div class="div-section-header">
                <b-row class="mt-4">
                    <b-col cols="12">
                        <div>
                            <span class="txt-section-title">Featured Content</span>
                        </div>
                    </b-col>
                </b-row>
            </div>

            <!-- Featured Class/Podcast/Blog -->
            <div class="div-section-body">
              <!-- Featured Cat Content -->
              <vpfeaturedcontent :fc=featuredClass :fp=featuredPodcast :fb=featuredBlog :fh=featuredHash></vpfeaturedcontent>
            </div>
          </div>

          <!-- LIVE WEBINARS -->
          <div v-if="webinars.length !== 0">
            <div class="div-section-header">
              <b-row class="mt-4">
                <b-col cols="12">
                  <div>
                    <span class="txt-section-title">Free Live Dental CE Webinars</span>
                  </div>
                </b-col>
                <b-col cols="8">
                    <span class="txt-section-subtitle">Showing Next {{webinars.length}} Upcoming</span>
                </b-col>
                <b-col cols="4" class="text-right">
                    <b-link v-if="webinars.length > 1" :to="{ path: '/upcoming', query: {cid: searchModel.catId, coid: searchModel.compId, q: searchModel.query}}">Show All</b-link>
                </b-col>
              </b-row>
            </div>

            <div class="div-section-body">
              <b-row v-for="(row,ix) in webinars" ref="rows" v-bind:key="row.classId" class="mt-2 mb-2 pointer" @click="gotoWebinar(ix,row)">
                <b-col cols="4" class="text-center">
                  <!-- {{row.classId}} -->
                    <b-img fluid v-bind:src="row.photo" />
                    <div v-if="row.isReserved" class="text-center reserved">RESERVED</div>
                    <div v-if="row.isWaiting" class="text-center waitlist">WAITLIST</div>
                </b-col>
                <b-col cols="8" style="margin-left: -20px;">
                  <div class="class-title">{{row.className}}</div>
                  <div class="class-details">
                    {{row.speakerName}}
                    <br>{{row.sponsorCompanyName}}
                    <span class="red">
                      <br>{{row.releaseDateUTC | prettyDateTime}}
                      <br>{{row.credits}} CEU ({{row.creditName}})
                    </span>
                  </div>
                </b-col>
              </b-row>
            </div>
          </div>

          <!-- ONDEMAND WEBINARS -->
          <div v-if="classes.length !== 0">
            <div class="div-section-header">
              <b-row class="mt-4">
                <b-col cols="12">
                  <div>
                    <span class="txt-section-title">On-Demand CE Webinars</span>
                  </div>
                </b-col>
                <b-col cols="8">
                    <span class="txt-section-subtitle">Showing {{classes.length}} Newest</span>
                </b-col>
                <b-col cols="4" class="text-right">
                    <b-link v-if="classes.length > 1" :to="{ path: '/ondemand', query: {cid: searchModel.catId, coid: searchModel.compId, q: searchModel.query}}">Show All</b-link>
                </b-col>
              </b-row>
            </div>

            <div class="div-section-body">
              <b-row v-for="row in classes" v-bind:key="row.classId" class="mt-2 mb-2 pointer" @click="gotoClass(row.hash)">
                  <b-col cols="4" class="text-center">
                    <b-img fluid v-bind:src="row.photo" />
                    <div v-if="row.examTaken" class="text-center completed">COMPLETED</div>
                  </b-col>
                  <b-col cols="8" style="margin-left: -20px;">
                    <div class="class-title">{{row.className}}</div>
                    <div class="class-details">
                      {{row.speakerName}}
                      <br>Sponsor: {{row.sponsorCompanyName}}
                      <br>{{row.releaseDateUTC | prettyDate}} - {{row.credits}} CEU ({{row.creditName}})
                    </div>
                    <div class="mt-2" v-if="false">
                      <b-button :to="{ path: '/classroom/'+row.hash }">Enter Classroom</b-button>
                    </div>
                  </b-col>
              </b-row>
            </div>
          </div>

          <!-- PODCASTS -->
          <div v-if="podcasts.length !== 0">
            <div class="div-section-header">
              <b-row class="mt-4">
                <b-col cols="12">
                  <div>
                    <span class="txt-section-title">Dental Podcasts</span>
                  </div>
                </b-col>
                <b-col cols="8">
                    <span class="txt-section-subtitle">Showing {{podcasts.length}} Newest</span>
                </b-col>
                <b-col cols="4" class="text-right">
                    <b-link v-if="podcasts.length > 1" :to="{ path: '/podcasts', query: {cid: searchModel.catId, coid: searchModel.compId, q: searchModel.query}}">Show All</b-link>
                </b-col>
              </b-row>
            </div>

            <div class="div-section-body">
              <b-row v-for="row in podcasts" v-bind:key="row.id" class="mt-2 mb-2 pointer" @click="gotoPodcast(row.podcastShowHash,row.hash)">
                <b-col cols="4" class="text-center">
                  <b-img fluid v-bind:src="row.photo" />
                  <div v-if="row.examTaken" class="text-center completed">COMPLETED</div>
                </b-col>
                <b-col cols="8" style="margin-left: -20px;">
                  <div class="class-title">{{row.title}}</div>
                  <div class="class-details">
                    {{row.speakerName}}
                    <br>Sponsor: {{row.companyName}}
                    <br>{{row.releaseDateUTC | prettyDate}}<span v-if="row.credits > 0"> - {{row.credits}} CEU (Self Study)</span>
                    <br><b-icon icon="clock"></b-icon>&nbsp;{{row.durationSec | prettySeconds}}
                  </div>
                </b-col>
              </b-row>
            </div>
          </div>  <!-- podcasts -->

          <!-- BLOGPOSTS -->
          <div v-if="blogPosts.length !== 0">
            <div class="div-section-header">
              <b-row class="mt-4">
                <b-col cols="12">
                  <div>
                    <span class="txt-section-title">Dental Blog</span>
                  </div>
                </b-col>
                <b-col cols="8">
                    <span class="txt-section-subtitle">Showing {{blogPosts.length}} Newest</span>
                </b-col>
                <b-col cols="4" class="text-right">
                    <b-link v-if="blogPosts.length > 1" :to="{ path: '/blog', query: {cid: searchModel.catId, coid: searchModel.compId, q: searchModel.query}}">Show All</b-link>
                </b-col>
              </b-row>
            </div>

            <div class="div-section-body">
              <b-row v-for="row in blogPosts" v-bind:key="row.id" class="pointer mt-2 pointer" @click.prevent="gotoBlogPost(row.id)">
                <b-col cols="12">
                  <div class="class-title">
                    <b-icon icon="caret-right-fill"></b-icon> <span v-if="row.featured" class="txt-blog-featured">Featured</span>{{ row.title }}
                    <!-- {{row.id}} -->
                  </div>
                  <div class="class-details">
                    {{ row.blurb }}
                  </div>
                </b-col>
              </b-row>

            </div>
          </div>  <!-- blogPosts -->

        </b-col>
      </b-row>
    </b-container>
  </b-overlay>
</template>

<script>
/* eslint-disable */

'use strict'

import service from "@/service/service";
import utils from "@/utils/utils";

export default {
  name: "Search",
  data() {
    return {
      debug: false,
      error: false,
      loading: true,
      busy: false,
      msg: 'Search',
      blurb: '',
      webinars: [],
      classes: [],
      podcasts: [],
      featuredClass: null,
      featuredHash: null,     // VpAdFeaturedContent.hash - to log click of featured content
      featuredPodcast: null,
      featuredBlog: null,
      studentData: {status: false},
      studentHash: this.$root.getToken() || '',
      seats: [],   // reserved seats
      bannerAds: [],
      searchModel: {
        path: '/search',
        label: 'Search All Content',
        catId: this.$route.query.cid || null,
        compId: this.$route.query.coid || null,
        query: this.$route.query.q || null
      }
    }
  },
  props: { },
  computed: {
    noResults() {
      let aout = (this.webinars.length == 0)
        && (this.classes.length == 0)
        && (this.podcasts.length == 0)
        && (this.blogPosts.length == 0)
      return aout
    }
   },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    gotoWebinar(ix, row) {
      if (row.isReserved || row.isWaiting) {
        this.$router.push(`/live/${row.hash}`)
      }
      else {
        this.$router.push(`/reserve/${row.hash}`)
      }
    },
    gotoClass(hash) {
      this.$router.push(`/classroom/${hash}`)
    },
    gotoPodcast(ps,p) {  // podcastShowHash, podcastHash
      this.$router.push(`/podcast/${ps}/${p}`)
    },
    gotoBlogPost(blogId) {
      this.$router.push(`/blog-post/${blogId}`)
    },
    gotoFeaturedClass(hash) {
      this.gotoClass(this.featuredClass.hash)
    },
    gotoFeaturedPodcast(ps,p) {  // podcastShowHash, podcastHash
      this.gotoPodcast(this.featuredPodcast.podcastShowHash, podcast.hash)
    },
    removeFilter() {
      this.searchModel.catId = null
      this.searchModel.compId = null
      this.searchModel.query = null
      this.doSearch()
    },
    doSearch() {
      this.loading = true
      // clearing these here puts busy spinner at top of page
      this.webinars = []
      this.seats = []
      this.classes = []
      this.podcasts = []
      this.blogPosts = []

      this.featuredClass = null
      this.featuredPodcast = null
      this.featuredBlog = null
      this.featuredHash = null

      service
        .getSearch(this.studentHash, this.searchModel.catId, this.searchModel.compId, this.searchModel.query)
        .then(
          (res => {
            // console.log(`back from getSearch`);
            if (this.debug) console.log(res);
            if (res.status) {
              if (res.webinars.status) {
                this.webinars = res.webinars.data
                this.seats = res.webinars.seats
                // console.log('seats'); console.log(this.seats)
                this.webinars.forEach( (row,ix) => this.webinars[ix].isReserved = row.hasSeat && !row.isWaiting )
                // below works too, but doesn't need seats[]
                // this.webinars.forEach( (row,ix) => this.webinars[ix].isReserved = this.seats.includes(row.classId) && !row.isWaiting )
              }
              else {
                this.webinars = []
                this.seats = []
              }
              this.classes = (res.classes.status) ? res.classes.data : []
              this.podcasts = (res.podcasts.status) ? res.podcasts.data : []
              this.blogPosts = (res.blogPosts.status) ? res.blogPosts.data : []

              if (res.featuredContent.status) {
                this.featuredClass = (res.featuredContent.featuredClass) ? res.featuredContent.featuredClass.data[0] : null
                this.featuredPodcast = (res.featuredContent.featuredPodcast) ? res.featuredContent.featuredPodcast.data[0] : null
                this.featuredBlog = (res.featuredContent.featuredBlog) ? res.featuredContent.featuredBlog.data[0] : null
                this.featuredHash = res.featuredContent.featuredHash
              }

              // TBD this.bannerAds = res.bannerAds.bannerAds
              // this.blurb = `All episodes from this series (${this.podcasts.length})`
            }
            else {
              this.error = true
            }
          }).bind(this)
        )
        .finally(e => {
          this.loading = false;
          console.log(`finally...`);
        })
        .catch(e => {
          this.error = true;
          console.log(e);
        })
    }
  },
  created() {
    // this.loading = false; return;
    // this.error = this.$root.getClassId() === 0;
    // console.log('SEARCH created')
    this.doSearch()
  },
  mounted() {
    // console.log('SEARCH mounted')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.txt-title-part1 {
  font-weight: bold;
  color: #aaa;
  font-size: 2rem;
}
.txt-title-part2 {
  /* font-weight: bold; */
  color: #66C;
  font-size: 1.8rem;
}
.txt-subtitle {
  font-weight: bold;
  font-size: 1.1rem;
  line-height: 130%;
}
.txt-section-title {
  font-weight: bold;
  color: black;
  font-size: 1.2rem;
}
.txt-section-subtitle {
  font-weight: bold;
  color: #66C;
  font-size: .9rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Search.vue